import React, { Component } from "react";
import "../style.css";
interface iProps {
  templateFileName: string;
  templateFileURL: string;
  description: string;
}
export default class TemplateDownload extends Component<iProps> {
  render() {
    let { templateFileName, templateFileURL, description } = this.props;
    return (
      <div>
        <div className="file-icon"></div>
        <div className="file-name">
          {templateFileName || `学生批量导入模板.xls`}
        </div>
        <a href={templateFileURL} className="download">
          点击下载
        </a>
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        ></div>
      </div>
    );
  }
}
